import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectBookingRoutes = [
  {
    path: 'booking',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Booking')
      },
      permissions: ['READ_BOOKING']
    },
    children: [
      {
        path: '',
        name: 'booking',
        component: wrapLegacyRoute('bookingController', 'booking')
      },
      {
        path: 'booking/:year/:month',
        name: 'bookingMonth',
        component: wrapLegacyRoute('bookingController', 'bookingMonth')
      }
    ]
  }
];

export default projectBookingRoutes;
